import { render, staticRenderFns } from "./t-button-save.vue?vue&type=template&id=350611ec&scoped=true&"
import script from "./t-button-save.vue?vue&type=script&lang=js&"
export * from "./t-button-save.vue?vue&type=script&lang=js&"
import style0 from "./t-button-save.vue?vue&type=style&index=0&id=350611ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350611ec",
  null
  
)

export default component.exports